import api from '../../../config/axios-interceptor';

export const fetchFeatureFlags = async () => {
    try {
        return await api.get('/api/v1/feature-flag/find-all');
    } catch (error) {
        console.error('❌ Error fetching feature flags:', error);
        throw error;
    }
};

/**
 * Update one flag.
 *
 * Sends only the fields being changed. A null means "leave as is"; clearing a restriction is done by
 * sending an empty string, which the server treats as unrestricted.
 */
export const updateFeatureFlag = async (key, patch) => {
    try {
        return await api.put(`/api/v1/feature-flag/${encodeURIComponent(key)}`, patch);
    } catch (error) {
        console.error('❌ Error updating feature flag:', error);
        throw error;
    }
};
